import React, { FC } from 'react';
import styled from 'styled-components';
import { KitFlexColCentered } from './KitFlexbox';
import KitIcon from './KitIcon';
import colors from '../common/theme/colors';
import constants from '../common/theme/constants';

export type ConditionalKitPageTitleProps =
  | {
      displayBack?: boolean;
      ariaLabelForBackButton?: string;
    }
  | {
      displayBack?: never;
      ariaLabelForBackButton: never;
    };

export interface KitPageTitleProps {
  category?: string;
  className?: string;
  title: string;
  onClickBack?: (event: React.MouseEvent<Element, MouseEvent>) => void;
}

const Title = styled.h1`
  &&& {
    font-size: ${({ theme }) => theme.headingFont.fontSize.text_20}rem;
    padding: 0;
    margin: 0;
    text-transform: capitalize;
    white-space: nowrap;
  }
`;

const Category = styled.div`
  color: ${colors.gray_40};
  font-size: ${constants.fontSize.text_12}rem;
  text-transform: uppercase;
`;

const Container = styled.div`
  display: flex;
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${constants.fontWeight.normal};
`;

const BackArrowContainer = styled(KitFlexColCentered)`
  max-width: 30px;
  padding-left: 0;
  padding-right: ${constants.spacing.absolute.s}px;
  cursor: pointer;
  justify-content: flex-end;
`;

const ArrowLeftIcon = styled(KitIcon)`
  width: auto;
  height: auto;
  max-width: none;
  min-width: auto;

  svg {
    height: 1em;
    font-size: ${constants.fontSize.text_20}rem;
  }
`;

const KitPageTitle: FC<KitPageTitleProps & ConditionalKitPageTitleProps> = ({
  title,
  category,
  className,
  onClickBack,
  displayBack,
  ariaLabelForBackButton,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    if (onClickBack) {
      event.preventDefault();
      onClickBack(event);
    }
  };

  return (
    <Container className={className}>
      {displayBack && (
        <BackArrowContainer
          aria-label={ariaLabelForBackButton}
          onClick={handleClick}
          role='button'
          tabIndex={0}
        >
          <ArrowLeftIcon icon='arrow-left' />
        </BackArrowContainer>
      )}
      <div>
        {category && <Category data-qa-id='page_category'>{category}</Category>}
        <Title data-qa-id='page_title'>{title}</Title>
      </div>
    </Container>
  );
};

export default KitPageTitle;
